import { noop as C, toValue as A, isObject as se, tryOnScopeDispose as B, isIOS as le, isClient as Q, useDebounceFn as ie, useThrottleFn as ue, toRef as ae, increaseWithUnit as ce, throttleFilter as fe, timestamp as q, createFilterWrapper as de } from "../../../../@vueuse_shared@10.5.0_vue@3.3.4/node_modules/@vueuse/shared/index.js";
import { debounceFilter as We, promiseTimeout as Ve, useInterval as ze, useIntervalFn as Be } from "../../../../@vueuse_shared@10.5.0_vue@3.3.4/node_modules/@vueuse/shared/index.js";
import { watch as F, computed as g, ref as E, shallowRef as U, reactive as z, readonly as V, watchEffect as ve, getCurrentInstance as pe, onMounted as he } from "vue";
function T(n) {
  var r;
  const t = A(n);
  return (r = t == null ? void 0 : t.$el) != null ? r : t;
}
const R = Q ? window : void 0;
function S(...n) {
  let r, t, i, s;
  if (typeof n[0] == "string" || Array.isArray(n[0]) ? ([t, i, s] = n, r = R) : [r, t, i, s] = n, !r)
    return C;
  Array.isArray(t) || (t = [t]), Array.isArray(i) || (i = [i]);
  const l = [], a = () => {
    l.forEach((d) => d()), l.length = 0;
  }, e = (d, v, c, p) => (d.addEventListener(v, c, p), () => d.removeEventListener(v, c, p)), o = F(
    () => [T(r), A(s)],
    ([d, v]) => {
      if (a(), !d)
        return;
      const c = se(v) ? { ...v } : v;
      l.push(
        ...t.flatMap((p) => i.map((h) => e(d, p, h, c)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    o(), a();
  };
  return B(u), u;
}
let Y = !1;
function Te(n, r, t = {}) {
  const { window: i = R, ignore: s = [], capture: l = !0, detectIframe: a = !1 } = t;
  if (!i)
    return;
  le && !Y && (Y = !0, Array.from(i.document.body.children).forEach((c) => c.addEventListener("click", C)), i.document.documentElement.addEventListener("click", C));
  let e = !0;
  const o = (c) => s.some((p) => {
    if (typeof p == "string")
      return Array.from(i.document.querySelectorAll(p)).some((h) => h === c.target || c.composedPath().includes(h));
    {
      const h = T(p);
      return h && (c.target === h || c.composedPath().includes(h));
    }
  }), d = [
    S(i, "click", (c) => {
      const p = T(n);
      if (!(!p || p === c.target || c.composedPath().includes(p))) {
        if (c.detail === 0 && (e = !o(c)), !e) {
          e = !0;
          return;
        }
        r(c);
      }
    }, { passive: !0, capture: l }),
    S(i, "pointerdown", (c) => {
      const p = T(n);
      p && (e = !c.composedPath().includes(p) && !o(c));
    }, { passive: !0 }),
    a && S(i, "blur", (c) => {
      setTimeout(() => {
        var p;
        const h = T(n);
        ((p = i.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(h != null && h.contains(i.document.activeElement)) && r(c);
      }, 0);
    })
  ].filter(Boolean);
  return () => d.forEach((c) => c());
}
function me() {
  const n = E(!1);
  return pe() && he(() => {
    n.value = !0;
  }), n;
}
function H(n) {
  const r = me();
  return g(() => (r.value, !!n()));
}
function P(n, r = {}) {
  const { window: t = R } = r, i = H(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let s;
  const l = E(!1), a = (u) => {
    l.value = u.matches;
  }, e = () => {
    s && ("removeEventListener" in s ? s.removeEventListener("change", a) : s.removeListener(a));
  }, o = ve(() => {
    i.value && (e(), s = t.matchMedia(A(n)), "addEventListener" in s ? s.addEventListener("change", a) : s.addListener(a), l.value = s.matches);
  });
  return B(() => {
    o(), e(), s = void 0;
  }), l;
}
const Oe = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
function Me(n, r = {}) {
  function t(e, o) {
    let u = n[e];
    return o != null && (u = ce(u, o)), typeof u == "number" && (u = `${u}px`), u;
  }
  const { window: i = R } = r;
  function s(e) {
    return i ? i.matchMedia(e).matches : !1;
  }
  const l = (e) => P(`(min-width: ${t(e)})`, r), a = Object.keys(n).reduce((e, o) => (Object.defineProperty(e, o, {
    get: () => l(o),
    enumerable: !0,
    configurable: !0
  }), e), {});
  return Object.assign(a, {
    greater(e) {
      return P(`(min-width: ${t(e, 0.1)})`, r);
    },
    greaterOrEqual: l,
    smaller(e) {
      return P(`(max-width: ${t(e, -0.1)})`, r);
    },
    smallerOrEqual(e) {
      return P(`(max-width: ${t(e)})`, r);
    },
    between(e, o) {
      return P(`(min-width: ${t(e)}) and (max-width: ${t(o, -0.1)})`, r);
    },
    isGreater(e) {
      return s(`(min-width: ${t(e, 0.1)})`);
    },
    isGreaterOrEqual(e) {
      return s(`(min-width: ${t(e)})`);
    },
    isSmaller(e) {
      return s(`(max-width: ${t(e, -0.1)})`);
    },
    isSmallerOrEqual(e) {
      return s(`(max-width: ${t(e)})`);
    },
    isInBetween(e, o) {
      return s(`(min-width: ${t(e)}) and (max-width: ${t(o, -0.1)})`);
    },
    current() {
      const e = Object.keys(n).map((o) => [o, l(o)]);
      return g(() => e.filter(([, o]) => o.value).map(([o]) => o));
    }
  });
}
function Re(n, r, t = {}) {
  const { window: i = R, ...s } = t;
  let l;
  const a = H(() => i && "MutationObserver" in i), e = () => {
    l && (l.disconnect(), l = void 0);
  }, o = F(
    () => T(n),
    (d) => {
      e(), a.value && i && d && (l = new MutationObserver(r), l.observe(d, s));
    },
    { immediate: !0 }
  ), u = () => {
    e(), o();
  };
  return B(u), {
    isSupported: a,
    stop: u
  };
}
function Ae(n, r = {}) {
  const t = E(!1), i = U(null);
  let s = 0;
  if (Q) {
    const l = typeof r == "function" ? { onDrop: r } : r, a = (e) => {
      var o, u;
      const d = Array.from((u = (o = e.dataTransfer) == null ? void 0 : o.files) != null ? u : []);
      return i.value = d.length === 0 ? null : d;
    };
    S(n, "dragenter", (e) => {
      var o;
      e.preventDefault(), s += 1, t.value = !0, (o = l.onEnter) == null || o.call(l, a(e), e);
    }), S(n, "dragover", (e) => {
      var o;
      e.preventDefault(), (o = l.onOver) == null || o.call(l, a(e), e);
    }), S(n, "dragleave", (e) => {
      var o;
      e.preventDefault(), s -= 1, s === 0 && (t.value = !1), (o = l.onLeave) == null || o.call(l, a(e), e);
    }), S(n, "drop", (e) => {
      var o;
      e.preventDefault(), s = 0, t.value = !1, (o = l.onDrop) == null || o.call(l, a(e), e);
    });
  }
  return {
    files: i,
    isOverDropZone: t
  };
}
function we(n, r, t = {}) {
  const { window: i = R, ...s } = t;
  let l;
  const a = H(() => i && "ResizeObserver" in i), e = () => {
    l && (l.disconnect(), l = void 0);
  }, o = g(() => Array.isArray(n) ? n.map((v) => T(v)) : [T(n)]), u = F(
    o,
    (v) => {
      if (e(), a.value && i) {
        l = new ResizeObserver(r);
        for (const c of v)
          c && l.observe(c, s);
      }
    },
    { immediate: !0, flush: "post", deep: !0 }
  ), d = () => {
    e(), u();
  };
  return B(d), {
    isSupported: a,
    stop: d
  };
}
function be(n, r = { width: 0, height: 0 }, t = {}) {
  const { window: i = R, box: s = "content-box" } = t, l = g(() => {
    var o, u;
    return (u = (o = T(n)) == null ? void 0 : o.namespaceURI) == null ? void 0 : u.includes("svg");
  }), a = E(r.width), e = E(r.height);
  return we(
    n,
    ([o]) => {
      const u = s === "border-box" ? o.borderBoxSize : s === "content-box" ? o.contentBoxSize : o.devicePixelContentBoxSize;
      if (i && l.value) {
        const d = T(n);
        if (d) {
          const v = i.getComputedStyle(d);
          a.value = Number.parseFloat(v.width), e.value = Number.parseFloat(v.height);
        }
      } else if (u) {
        const d = Array.isArray(u) ? u : [u];
        a.value = d.reduce((v, { inlineSize: c }) => v + c, 0), e.value = d.reduce((v, { blockSize: c }) => v + c, 0);
      } else
        a.value = o.contentRect.width, e.value = o.contentRect.height;
    },
    t
  ), F(
    () => T(n),
    (o) => {
      a.value = o ? r.width : 0, e.value = o ? r.height : 0;
    }
  ), {
    width: a,
    height: e
  };
}
const ye = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"], ge = 6e4;
function $e(n = ge, r = {}) {
  const {
    initialState: t = !1,
    listenForVisibilityChange: i = !0,
    events: s = ye,
    window: l = R,
    eventFilter: a = fe(50)
  } = r, e = E(t), o = E(q());
  let u;
  const d = () => {
    e.value = !1, clearTimeout(u), u = setTimeout(() => e.value = !0, n);
  }, v = de(
    a,
    () => {
      o.value = q(), d();
    }
  );
  if (l) {
    const c = l.document;
    for (const p of s)
      S(l, p, v, { passive: !0 });
    i && S(c, "visibilitychange", () => {
      c.hidden || v();
    }), d();
  }
  return {
    idle: e,
    lastActive: o,
    reset: d
  };
}
const N = 1;
function De(n, r = {}) {
  const {
    throttle: t = 0,
    idle: i = 200,
    onStop: s = C,
    onScroll: l = C,
    offset: a = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: e = {
      capture: !1,
      passive: !0
    },
    behavior: o = "auto",
    window: u = R
  } = r, d = E(0), v = E(0), c = g({
    get() {
      return d.value;
    },
    set(f) {
      h(f, void 0);
    }
  }), p = g({
    get() {
      return v.value;
    },
    set(f) {
      h(void 0, f);
    }
  });
  function h(f, w) {
    var m, L, O;
    if (!u)
      return;
    const x = A(n);
    x && ((O = x instanceof Document ? u.document.body : x) == null || O.scrollTo({
      top: (m = A(w)) != null ? m : p.value,
      left: (L = A(f)) != null ? L : c.value,
      behavior: A(o)
    }));
  }
  const _ = E(!1), b = z({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), y = z({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), M = (f) => {
    _.value && (_.value = !1, y.left = !1, y.right = !1, y.top = !1, y.bottom = !1, s(f));
  }, D = ie(M, t + i), I = (f) => {
    var w;
    if (!u)
      return;
    const m = f.document ? f.document.documentElement : (w = f.documentElement) != null ? w : f, { display: L, flexDirection: O } = getComputedStyle(m), x = m.scrollLeft;
    y.left = x < d.value, y.right = x > d.value;
    const k = Math.abs(x) <= 0 + (a.left || 0), G = Math.abs(x) + m.clientWidth >= m.scrollWidth - (a.right || 0) - N;
    L === "flex" && O === "row-reverse" ? (b.left = G, b.right = k) : (b.left = k, b.right = G), d.value = x;
    let $ = m.scrollTop;
    f === u.document && !$ && ($ = u.document.body.scrollTop), y.top = $ < v.value, y.bottom = $ > v.value;
    const X = Math.abs($) <= 0 + (a.top || 0), j = Math.abs($) + m.clientHeight >= m.scrollHeight - (a.bottom || 0) - N;
    L === "flex" && O === "column-reverse" ? (b.top = j, b.bottom = X) : (b.top = X, b.bottom = j), v.value = $;
  }, W = (f) => {
    var w;
    if (!u)
      return;
    const m = (w = f.target.documentElement) != null ? w : f.target;
    I(m), _.value = !0, D(f), l(f);
  };
  return S(
    n,
    "scroll",
    t ? ue(W, t, !0, !1) : W,
    e
  ), S(
    n,
    "scrollend",
    M,
    e
  ), {
    x: c,
    y: p,
    isScrolling: _,
    arrivedState: b,
    directions: y,
    measure() {
      const f = A(n);
      u && f && I(f);
    }
  };
}
function Pe(n, r = {}) {
  const t = ae(n), {
    threshold: i = 50,
    onSwipe: s,
    onSwipeEnd: l,
    onSwipeStart: a
  } = r, e = z({ x: 0, y: 0 }), o = (f, w) => {
    e.x = f, e.y = w;
  }, u = z({ x: 0, y: 0 }), d = (f, w) => {
    u.x = f, u.y = w;
  }, v = g(() => e.x - u.x), c = g(() => e.y - u.y), { max: p, abs: h } = Math, _ = g(() => p(h(v.value), h(c.value)) >= i), b = E(!1), y = E(!1), M = g(() => _.value ? h(v.value) > h(c.value) ? v.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), D = (f) => {
    var w, m, L;
    const O = f.buttons === 0, x = f.buttons === 1;
    return (L = (m = (w = r.pointerTypes) == null ? void 0 : w.includes(f.pointerType)) != null ? m : O || x) != null ? L : !0;
  }, I = [
    S(n, "pointerdown", (f) => {
      var w, m;
      if (!D(f))
        return;
      y.value = !0, (m = (w = t.value) == null ? void 0 : w.style) == null || m.setProperty("touch-action", "none");
      const L = f.target;
      L == null || L.setPointerCapture(f.pointerId);
      const { clientX: O, clientY: x } = f;
      o(O, x), d(O, x), a == null || a(f);
    }),
    S(n, "pointermove", (f) => {
      if (!D(f) || !y.value)
        return;
      const { clientX: w, clientY: m } = f;
      d(w, m), !b.value && _.value && (b.value = !0), b.value && (s == null || s(f));
    }),
    S(n, "pointerup", (f) => {
      var w, m;
      D(f) && (b.value && (l == null || l(f, M.value)), y.value = !1, b.value = !1, (m = (w = t.value) == null ? void 0 : w.style) == null || m.setProperty("touch-action", "initial"));
    })
  ], W = () => I.forEach((f) => f());
  return {
    isSwiping: V(b),
    direction: V(M),
    posStart: V(e),
    posEnd: V(u),
    distanceX: v,
    distanceY: c,
    stop: W
  };
}
function Ce(n, r) {
  const { containerStyle: t, wrapperProps: i, scrollTo: s, calculateRange: l, currentList: a, containerRef: e } = "itemHeight" in r ? Se(r, n) : xe(r, n);
  return {
    list: a,
    scrollTo: s,
    containerProps: {
      ref: e,
      onScroll: () => {
        l();
      },
      style: t
    },
    wrapperProps: i
  };
}
function Z(n) {
  const r = E(null), t = be(r), i = E([]), s = U(n);
  return { state: E({ start: 0, end: 10 }), source: s, currentList: i, size: t, containerRef: r };
}
function K(n, r, t) {
  return (i) => {
    if (typeof t == "number")
      return Math.ceil(i / t);
    const { start: s = 0 } = n.value;
    let l = 0, a = 0;
    for (let e = s; e < r.value.length; e++) {
      const o = t(e);
      if (l += o, a = e, l > i)
        break;
    }
    return a - s;
  };
}
function J(n, r) {
  return (t) => {
    if (typeof r == "number")
      return Math.floor(t / r) + 1;
    let i = 0, s = 0;
    for (let l = 0; l < n.value.length; l++) {
      const a = r(l);
      if (i += a, i >= t) {
        s = l;
        break;
      }
    }
    return s + 1;
  };
}
function ee(n, r, t, i, { containerRef: s, state: l, currentList: a, source: e }) {
  return () => {
    const o = s.value;
    if (o) {
      const u = t(n === "vertical" ? o.scrollTop : o.scrollLeft), d = i(n === "vertical" ? o.clientHeight : o.clientWidth), v = u - r, c = u + d + r;
      l.value = {
        start: v < 0 ? 0 : v,
        end: c > e.value.length ? e.value.length : c
      }, a.value = e.value.slice(l.value.start, l.value.end).map((p, h) => ({
        data: p,
        index: h + l.value.start
      }));
    }
  };
}
function te(n, r) {
  return (t) => typeof n == "number" ? t * n : r.value.slice(0, t).reduce((s, l, a) => s + n(a), 0);
}
function ne(n, r, t) {
  F([n.width, n.height, r], () => {
    t();
  });
}
function oe(n, r) {
  return g(() => typeof n == "number" ? r.value.length * n : r.value.reduce((t, i, s) => t + n(s), 0));
}
const Ee = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function re(n, r, t, i) {
  return (s) => {
    i.value && (i.value[Ee[n]] = t(s), r());
  };
}
function xe(n, r) {
  const t = Z(r), { state: i, source: s, currentList: l, size: a, containerRef: e } = t, o = { overflowX: "auto" }, { itemWidth: u, overscan: d = 5 } = n, v = K(i, s, u), c = J(s, u), p = ee("horizontal", d, c, v, t), h = te(u, s), _ = g(() => h(i.value.start)), b = oe(u, s);
  ne(a, r, p);
  const y = re("horizontal", p, h, e), M = g(() => ({
    style: {
      height: "100%",
      width: `${b.value - _.value}px`,
      marginLeft: `${_.value}px`,
      display: "flex"
    }
  }));
  return {
    scrollTo: y,
    calculateRange: p,
    wrapperProps: M,
    containerStyle: o,
    currentList: l,
    containerRef: e
  };
}
function Se(n, r) {
  const t = Z(r), { state: i, source: s, currentList: l, size: a, containerRef: e } = t, o = { overflowY: "auto" }, { itemHeight: u, overscan: d = 5 } = n, v = K(i, s, u), c = J(s, u), p = ee("vertical", d, c, v, t), h = te(u, s), _ = g(() => h(i.value.start)), b = oe(u, s);
  ne(a, r, p);
  const y = re("vertical", p, h, e), M = g(() => ({
    style: {
      width: "100%",
      height: `${b.value - _.value}px`,
      marginTop: `${_.value}px`
    }
  }));
  return {
    calculateRange: p,
    scrollTo: y,
    containerStyle: o,
    wrapperProps: M,
    currentList: l,
    containerRef: e
  };
}
export {
  Oe as breakpointsTailwind,
  de as createFilterWrapper,
  We as debounceFilter,
  R as defaultWindow,
  ce as increaseWithUnit,
  Q as isClient,
  le as isIOS,
  se as isObject,
  C as noop,
  Te as onClickOutside,
  Ve as promiseTimeout,
  fe as throttleFilter,
  q as timestamp,
  ae as toRef,
  A as toValue,
  B as tryOnScopeDispose,
  T as unrefElement,
  Me as useBreakpoints,
  ie as useDebounceFn,
  Ae as useDropZone,
  be as useElementSize,
  S as useEventListener,
  $e as useIdle,
  ze as useInterval,
  Be as useIntervalFn,
  P as useMediaQuery,
  me as useMounted,
  Re as useMutationObserver,
  Pe as usePointerSwipe,
  we as useResizeObserver,
  De as useScroll,
  H as useSupported,
  ue as useThrottleFn,
  Ce as useVirtualList
};
